<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('dashboard')" :isFilter="false">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('dashboard')" :isFilter="false">
                </HeaderMobile>
            </template>
            <div class="row">
                <div class="col-md-9">
                    <h5>{{ $t('announcement') }}</h5>
                    <div v-if="announcements?.length == 0">
                       <p>{{ $t('no_announcements') }}</p>
                    </div>
                    <div class="border rounded mb-5">
                        <b-carousel v-model="currentIndex" :controls="visibleAnnouncements.length > 0" :indicators="false" :interval="null">
                            <b-carousel-slide
                                v-for="(announcement, index) in visibleAnnouncements"
                                :key="index"
                                :style="{ height: '150px' }"
                            >
                                <b-row>
                                    <b-col v-for="(announcement, colIndex) in announcement" :key="colIndex" cols="6">
                                        <b-card class="bg-light rounded cursor-pointer" @click="goAnnouncements(announcement)">
                                            <b-card-title>
                                                {{ truncateText(getLocaleText(announcement, 'subject').toUpperCase()) }}
                                            </b-card-title>
                                        </b-card>
                                    </b-col>
                                </b-row>
                            </b-carousel-slide>
                        </b-carousel>
                    </div>
                </div>
                <div class="col-md-3" v-if="pdfManuals && pdfManuals.items.length && checkPermission('parameteritem_filebytoken') && checkPermission('parameteritem_filetoken')" >
                    <div class="d-flex justify-content-end mb-3">
                        <div style="min-width: 300px">
                            <h5>{{ $t('guide') }}</h5>
                            <div class="border rounded p-4 pt-5 pb-5 bg-light">
                                <div
                                    class="d-flex align-items-center font-size-14 mb-2 btn-link cursor-pointer"
                                    v-for="item in pdfManuals?.items" @click="openFileToken(item)"
                                >
                                    <i class="ri-book-open-line mr-2 ri-2x mr-2"></i>
                                    {{ item.name }}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div v-if="isStudent">
                <div class="col-10" v-show="user.active_student_program?.active_semester_status != '101' && user.active_semester?.semester != 3">
                    <AlertComponent :user="user.active_student_program?.active_semester_status" />
                </div>
                <div class="col-10" v-show="user.active_student_program?.nationality_code != 'TR'">
                    <ForeignStudentWarning :user="user.active_student_program?.active_semester_status" />
                </div>
                <div class="col-10" v-show="user?.student_information_messages && (user?.student_information_messages?.tr || user?.student_information_messages?.en)">
                    <StudentInformationAlertComponent :user="user" />
                </div>
            </div>
            <div v-if="isStudent || isOfficial">
                <div class="d-flex flex-column flex-lg-row justify-content-between">
                    <div class="flex-grow-1 mr-0 mr-md-5">
                        <div class="row" v-if="checkDoubleMajorStatus">
                            <div class="col-12">
                                <b-alert variant="danger" show dismissible>
                                    <div v-html="doubleMajorText">

                                    </div>
                                </b-alert>
                            </div>
                        </div>
                        <h5>{{ $t('fast_transactions') }}</h5>
                        <div class="border rounded p-4">
                            <b-row>
                                <b-col cols="12" sm="6" md="4" lg="3" v-for="(menu, menuKey) in menus"
                                    :key="'menu' + menuKey">
                                    <div class="bg-light rounded p-4 mb-4 cursor-pointer" @click="goToUrl(menu.url)" >
                                        {{ getLocaleText(menu, 'name').toUpper() }}
                                    </div>
                                </b-col>
                                <b-col cols="12" sm="6" md="4" lg="3" v-for="(button, index) in applicationButtons"
                                    :key="index">
                                    <a :href="button.url" :target="button.target">
                                        <div class="bg-light rounded p-4 mb-4 cursor-pointer">
                                            {{ getLocaleText(button, 'name').toUpper() }}
                                        </div>
                                    </a>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                    <div style="min-width: 300px" class="mt-3">
                        <h5>{{ $t('help') }}</h5>
                        <div class="border rounded p-4 pt-5 pb-5 bg-light">
                            <a href="https://bau.edu.tr/help" target="_blank">
                                <div class="d-flex align-items-center font-size-16 mb-2 btn-link cursor-pointer">
                                    <i class="ri-question-line mr-2"></i> {{ $t('contact_support') }}
                                </div>
                            </a>
                            <div class="d-flex align-items-center font-size-16 btn-link cursor-pointer"
                                @click="getUserGuide">
                                <i class="ri-book-open-line mr-2"></i> {{ $t('user_quide') }}
                            </div>
                        </div>
                        <Surveys :surveys="nonMandatorySurveys" v-if="nonMandatorySurveys.length > 0"/>
                    </div>
                </div>
            </div>
            <CommonModal ref="kvkk1Modal" size="xl" :closeBtn="false" :onHideOnlyX="true">
                <template v-slot:CommonModalTitle>
                    <div>{{ $t('statement_3').toUpper() }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <div>
                        <div class="row">
                            <div v-html="kvkkChosenContent" class="col-12">
                            </div>
                        </div>
                        <b-button class="btn--primary" @click="continueProcess">{{
                    $t('read_and_accept')
                            }}
                        </b-button>
                    </div>
                </template>
            </CommonModal>
            <CommonModal ref="announcementModal" size="lg" :onHideOnlyX="true">
                <template v-slot:CommonModalTitle>
                    <div>{{ getLocaleText(selectedAnnouncement, 'subject').toUpper() }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <div>
                        <div class="row border rounded mb-5">
                            <p class="p-3">{{ decodeHTMLEntities(getLocaleText(selectedAnnouncement, 'explanation')) }}</p>
                        </div>
                    </div>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from '@/layouts/AppLayout'
import Header from '@/layouts/AppLayout/Header'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

// Component
import PasswordInput from '@/components/elements/PasswordInput'
import PasswordInputWithStrength from '@/components/elements/PasswordInputWithStrength'
import CommonModal from "@/components/elements/CommonModal";
import AlertComponent from "@/components/elements/AlertComponent.vue";
import StudentInformationAlertComponent from "@/components/elements/StudentInformationAlertComponent.vue";


// Services
import DashboardService from '@/services/DashboardService'
import StudentProgramService from "@/services/StudentProgramService";
import StudentService from "@/services/StudentService";
import Base from '@/plugins/Base'
import ConstantService from "@/services/ConstantService"
import AnnouncementsService from "@/services/AnnouncementsService"
import ParameterService from "@/services/ParameterService";

//Other
import qs from "qs";
import ForeignStudentWarning from "@/components/page/ForeignStudentWarning.vue";
import Surveys from "@/modules/dashboard/pages/components/Surveys.vue";

export default {
    name: "DashboardPage",
    components: {
        Surveys,
        ForeignStudentWarning,
        AlertComponent,
        StudentInformationAlertComponent,
        AppLayout,
        Header,
        HeaderMobile,
        PasswordInput,
        PasswordInputWithStrength,
        CommonModal,
        ParameterService,

    },
    metaInfo() {
        return {
            title: this.$t('dashboard')
        }
    },
    data() {
        return {
            userStore: {},
            kvkkChosenContent: null,
            applicationButtons: [],
            doubleMajorText: null,
            announcements: null,
            selectedAnnouncement: null,
            currentIndex: 0,
            pdfManuals: null,
        }
    },
    created() {
        this.kvkkCheck()
        this.$store.dispatch("dashboard/getAppImages");
        //this.getStudentApplicationStatus()
        this.getMeAnnouncement()
        this.getPdfManuals(this.$i18n.locale)
    },
    computed: {
        visibleAnnouncements() {
            let groupedAnnouncements = [];
            for (let i = 0; i < this.announcements?.length; i += 2) {
                groupedAnnouncements.push(this.announcements.slice(i, i + 2));
            }
            return groupedAnnouncements;
        },
        user() {
            return this.$store.getters['auth/getUser'];
        },
        menus() {
            let menus = this.$store.getters['auth/getMenus'];
            let data = []
            const activeProgram=this.user.active_student_program
            if (menus && menus.length > 0) {
                menus.forEach((menu) => {
                    if (menu.items && menu.items.length > 0) {
                        menu.items.forEach((item) => {
                            if(item.items && item.items.length > 0) {
                                item.items.forEach((item2) => {
                                    data.push(item2)
                                })
                            } else {
                                if (activeProgram && item.url==='/thesis/and/project/student' && ['34'].includes(activeProgram.faculty_code) && !activeProgram.with_thesis) {
                                    return
                                }
                                data.push(item)
                            }
                        })
                    }
                })
            }
            return data
        },
        isAdmin() {
            return this.$store.getters['auth/isAdmin'];
        },
        isStudent() {
            return this.$store.getters['auth/isStudent'];
        },
        isOfficial() {
            return this.$store.getters['auth/isOfficial'];
        },
        checkDoubleMajorStatus() {
            if (this.user?.active_student_program?.major_type == 'C') {
                let result = []
                this.user.student.student_program.forEach(itm => {
                    if (itm.major_type == 'A' && ['112', '122', '121'].includes(itm.last_semester_status)) {
                        result.push(itm)
                    }
                })

                if (result.length > 0) {
                    const key = this.$i18n.locale == 'tr' ? "double_major_minor_semester_status_warning_text_tr" : "double_major_minor_semester_status_warning_text_en"
                    this.ConstantServiceGetValue(key)
                    return true
                } else {
                    return false
                }
            } else if (this.user?.active_student_program?.major_type ==='A') {
                let result = this.user.student.student_program.filter((item)=> ['112','122','121'].includes(item.last_semester_status) && (['Y'].includes(item.major_type) || ['C'].includes(item.major_type)))

                if (result.length > 0) {
                    const key = this.$i18n.locale == 'tr' ? "major_semester_status_warning_text_tr" : "major_semester_status_warning_text_en"
                    this.ConstantServiceGetValue(key)
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }

        },
        nonMandatorySurveys(){
            if (!this.user)return []
            if (this.user.surveys && this.user.surveys.length > 0){
                return this.user.surveys.filter(item=>!item.necessity)
            }else {
                return  []
            }
        }
    },
    watch:{
      'this.$i18n.locale'(newVal){
          this.getPdfManuals(newVal)
      }
    },
    methods: {
        goToUrl(url) {
            this.$router.push(url)
        },
        getUserGuide() {
            let config = {
                params: {
                    language: this.$i18n.locale,
                    timer: new Date()
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            }

            DashboardService.getUserGuide(config)
                .then(response => {
                    this._downloadFile(response, 'BAU-' + this.$t('file_name_student_information_system') + '-' + this.$t('file_name_user_guide') + '.pdf')
                })
                .catch(e => {
                    this.$toast.error(this.$t('api.' + e.data.message));
                })
        },
        getPdfManuals(language){
            const  code="kilavuz_"
            const parameter = code + language
            ParameterService.getItems(parameter).then(response=>{
                this.pdfManuals=response.data.data
            });
        },
        openFileToken(item){
            let data = {
                id: item.id,
                uuid: item.media[0].uuid
            }
            DashboardService.createFileToken(data).then(response=>{
                item.url=process.env.VUE_APP_ENDPOINT_STUDENT + '/parameter/items/file-by-token/'+response.data.data;
                window.open(item.url, '_blank')
            });
        },
        continueProcess() {
            StudentProgramService.approveKvkk()
                .then(() => {
                    this.$toast.success(this.$t('proccess_success'));
                    this.$refs.kvkk1Modal.$refs.commonModal.hide()
                    this.userStore.kvkk_status = true
                    this.$store.dispatch("auth/restoreUserInfo", this.userStore);
                })
                .catch(err => this.showErrors(err))
        },

        kvkkCheck() {
            this.$store.dispatch('auth/getUser').then(() => {
                let store = (Base.LocalStorage.get('user') || {});
                this.userStore = store
                if (!store.kvkk_status && store.student != null) {
                    this.kvkkChosenContent = ['YL', 'D'].includes(this.userStore.active_student_program.program_level) ? this.$t('kvkk_content') : this.$t('kvkk_lisans_content')
                    this.$refs.kvkk1Modal.$refs.commonModal.show()
                }

            });
        },
        async getStudentApplicationStatus() {
            const response = await StudentService.studentApplicationStatus().catch((e) => {
                if (e.data.message) {
                    this.$toast.error(this.$t("api." + e.data.message));
                }
            });
            this.applicationButtons = response.data.data.filter(item => item.status)
        },
        ConstantServiceGetValue(text) {
            const config = {
                params: {
                    key: text
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };
            ConstantService.getValue(config).then(response => {
                this.doubleMajorText = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },
        getMeAnnouncement() {
            AnnouncementsService.getAllAnnouncement().then(response => {
                this.announcements = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },
        truncateText(text, maxLength) {
            if (!text) return "";
            return text.length > maxLength
                ? text.substring(0, maxLength) + "..."
                : text;
        },
        goAnnouncements(announcement) {
            this.selectedAnnouncement = announcement
            this.$refs.announcementModal.$refs.commonModal.show()
        }

    }
}
</script>

<style scope>
a,
a:hover {
    color: #141414;
}
.carousel-control-prev-icon,
.carousel-control-next-icon {
    background-color: transparent !important;
    filter: invert(1) grayscale(1) contrast(100%) brightness(0) !important;
}

</style>
